import { useEffect, useState, useRef } from "react";
import { TrainingAPI } from "../../api/TrainingAPI";
import { Navbar } from "../Navigation/Navbar";
import "../../Styles/styles-Reports.css";
import { useSelector, useDispatch } from "react-redux";
// import { findDOMNode } from 'react-dom';
import {
  Button,
  Collapse,
  Dropdown,
  DatePicker,
  Checkbox,
  Col,
  Modal,
  Row,
  Spin,
  Tooltip,
  Typography,
  notification
 } from 'antd'
import { CaretDownOutlined } from '@ant-design/icons';
import { NicknameDialog } from "../Upload/NicknameDialog";
import { OutlierDialog } from "../Upload/OutlierDialog";
import { HelpButton } from "../Common/HelpButton";
import { audioMessage } from "../Common/Notifications/audioMessage";
import { audioNotification } from "../Common/Notifications/audioNotification";
import { getAllTeamMetricsByType } from "../../store/actions/team.actions";
import { RealTimeMessageNotification } from "../Common/RealTimeMessageNotification";
import { WeatherDialog } from "../Upload/WeatherDialog";
import { SnapCountDialog } from "../Upload/SnapCountDialog";


const { Text } = Typography;

const DATA_TYPE_MAPPING = [
  {key: 'gps', label: 'GPS', disabled: false},
  {key: 'wellness', label: 'Wellness (Coming soon)', disabled: true},
  {key: 'testing', label: 'Testing', disabled: false},
  {key: 'forceplate', label: 'Force Plate', disabled: false},
  {key: 'body_weight', label: 'Body Weight', disabled: false},
]

export const Reports = ({ 
  isSkippable = false, 
  handlePrevClick = () => {},
  stepNum = 0,
  reportParams={},
  dateRange=null,
  PostSubmitReset = () => {},
}) => {
  const dispatch = useDispatch();

  const trainingAPI = new TrainingAPI();
  const reportParamsAvailable = Object.keys(reportParams).length > 0;
  const [reportType, setReportType] = useState('');
  const [dailyReportTypes, setDailyReportTypes] = useState([]);
  const [reportDate, setReportDate] = useState(null);
  const [reportDateMoment, setReportDateMoment] = useState(null);
  const [groupByPos, setGroupByPos] = useState(false);
  const [showGroupByPos, setShowGroupByPos] = useState(false);
  const [dateRangeWeather, setDateRangeWeather] = useState(null);
  const [showDailyReportType, setShowDailyReportType] = useState(false);
  const [selectedDataType, setSelectedDataType] = useState([]);
  const [pickerVisible, setPickerVisible] = useState(false);
  const [loadingDataType, setLoadingDataType] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(!reportParamsAvailable);
  const [isPrevBtnDisabled, setIsPrevBtnDisabled] = useState(false);
  const [selectedEmails, setSelectedEmails] = useState({});
  const [currentUserEmail, setCurrentUserEmail] = useState("");
  const [dailyReportDataTypeForDate, setDailyReportDatatypeForDate] = useState(DATA_TYPE_MAPPING);
  const [nicknameDialogIsOpen, setNicknameDialogIsOpen] = useState(false);
  const [outlierDialogIsOpen, setOutlierDialogIsOpen] = useState(false);
  const [outliers, setOutliers] = useState([]);
  const [missingPlayerName, setMissingPlayerName] = useState("");
  const groupByPosFor = ['forceplate', 'testing'];
  const [uuid, setUuid] = useState(null);
  const [showLiveLoading, setShowLiveLoading] = useState(false);
  const [uploadSummariesBySource, setUploadSummariesBySource] = useState({});
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [weatherDialogVisible, setWeatherDialogVisible] = useState(false);
  const [snapCountDialogVisible, setSnapCountDialogVisible] = useState(false);
  const [projectedSnapCounts, setProjectedSnapCounts] = useState(null);
  const {
    info
  } = useSelector(({ team }) => team);
  const {
    all_metric_types: allMetricTypes,
    info: {
      coach_list: coach_list,
      sport,
      dataviz_lite: datavizLite,
      integrations
    },
  } = useSelector(({ team }) => team);

  const integrationsByKey = integrations
    ? Object.values(integrations).flat().reduce((acc, item) => { acc[item.key] = item; return acc; }, {})
    : {};

  let items = [
    {
      label: 'GPS',
      key: 'gps',
    },
    {
      label: "Coach's Report (GPS)",
      key: 'coach',
    },
    // {
    //   label: 'Wellness',
    //   key: 'wellness',
    // },
    {
      label: 'Force Plate',
      key: 'forceplate',
    },
    {
      label: 'Testing',
      key: 'testing',
    },
    {
      label: 'Daily (All Tech)',
      key: 'daily_all_tech',
    },
    {
      label: 'Weekly (Coming Soon)',
      key: 'weekly',
      disabled: true,
    },
  ];
  items = items.filter(item => {
    if (isSkippable && item?.key === 'daily_all_tech') return false;
    if (item.key === "gps" && datavizLite) return false; // hide GPS for dataviz_lite users
    // check if tech stream is valid = any metrics in that tech stream
    if (Object.keys(allMetricTypes).includes(item.key) && allMetricTypes[item.key]?.length === 0) return false;

    return true;
  })

  useEffect(() => {
    trainingAPI
    .getCurrentUserData()
    .then((x) => setCurrentUserEmail(x.email));
  }, []);

  useEffect(() => {
    getDailyReportDataTypes(reportType, reportDate);
  }, [reportDate]);

  useEffect(() => {
    if (reportParams?.requested_sources?.includes('catapult') && ["Las Vegas Raiders", "Demo Team - Charlie"].includes(info?.display_name)) {
      setWeatherDialogVisible(true);
    }
  }, [reportParams, info]);

  useEffect(() => {
    if (reportParams?.requested_sources?.includes('snap-data')) {
      setSnapCountDialogVisible(true);
    }
  }, [reportParams]);

  const handleSnapCountSubmit = (snapCounts) => {
    setProjectedSnapCounts(snapCounts);
    setSnapCountDialogVisible(false);
  };

  const getDailyReportDataTypes = async (reportType, date) => {
    if(reportType === "daily_all_tech" && date !== null ) {
      setShowDailyReportType(true);

      try {
        setLoadingDataType(true);
        const dataTypesObject = await trainingAPI.getDataTypesForReport(date);
        const key_to_label = {
          "gps": "GPS",
          "wellness": "Wellness (Coming Soon)",
          "testing": "Testing",
          "forceplate": "Force Plate",
          "body_weight": "Body Weight",
        };
        const dataTypesForDate = Object.keys(dataTypesObject).map( (data_type) => {
          return {
            key: data_type,
            label: key_to_label[data_type],
            disabled: !dataTypesObject[data_type]
          }
        })
        setDailyReportDatatypeForDate(dataTypesForDate);
        // setSelectedDataType(dataTypesArray);
        // setLoadingDataType(false);
      } catch (error) {
        setDailyReportDatatypeForDate(DATA_TYPE_MAPPING);
        // setLoadingDataType(false);
        console.error(error)
        // message.error("Error retrieving data types for team!");
      } finally {
        setLoadingDataType(false);
      }
    }
    else setShowDailyReportType(false);

  };

  const handleMenuClick = (e) => {
    const selectedKey = items.find(item => item.key === e.key)?.key;
    setReportType(selectedKey || 'Select Report Type');

    // Hide/Show Group By Position
    if (groupByPosFor.includes(selectedKey)) setShowGroupByPos(true);
    else setShowGroupByPos(false);

    // Hide Show Daily Report Data Type
    getDailyReportDataTypes(selectedKey, reportDate);

    setIsSubmitDisabled(!(
      selectedKey !== "" && 
      reportDate !== null //&& 
      //Object.values(selectedEmails).some(value => value === true)
    ));
  };
  const handleWeatherSubmit = (weatherData) => {
    setDateRangeWeather(weatherData);
    setWeatherDialogVisible(false);
  };

  const toggleNicknameDialog = (e) => {
    e.preventDefault();
    setNicknameDialogIsOpen(!nicknameDialogIsOpen);
  }

  const toggleOutlierDialog = (e) => {
    e.preventDefault();
    setOutlierDialogIsOpen(!outlierDialogIsOpen);
  }

  const setUpdatedOutliers = (updatedOutliers) => {
    setOutliers(updatedOutliers);
    audioNotification.destroy('outlier-notification');
  }

  const menu = {
    items,
    onClick: handleMenuClick,
  };

  const dateRangeSelectionChange = (date, dateString) => {

    dateString = (dateString.length === 0 ? null : dateString);
    setReportDate(dateString);
    setReportDateMoment(date);
    setPickerVisible(false);
    // Hide Show Daily Report Data Type
    getDailyReportDataTypes(reportType, dateString);

    setIsSubmitDisabled(!(
      reportType !== "" && 
      dateString !== null //&& 
      //Object.values(selectedEmails).some(value => value === true)
    ));
  };

  const onToggleGroupByPos = (checked) => {
		setGroupByPos(!groupByPos);
	};

  const handleEmailSelectionChange = (option) => {
    let emails = {
      ...selectedEmails,
      [option]: !selectedEmails[option],
    };
    setSelectedEmails(emails);

    setIsSubmitDisabled(!(
      reportType !== "" && 
      reportDate !== null //&& 
      //Object.values(emails).some(value => value === true)
    ));
  };

  const handleSubmitReport = () => {
    setIsPrevBtnDisabled(true);
    setLoading(true);

    if (reportParams?.requested_sources?.includes('gymaware') && dateRange[1].diff(dateRange[0], 'months', true) > 1) {
      audioMessage.info("Start and End date must be within 1 month of each other");
      setLoading(false);
      return;
    }


    const localReportType = reportType === 'coach' ? 'gps': reportType;
    let request = null;
    let successMessage = "";
    // Get all emails which are checked
    let emails = Object.keys(selectedEmails).filter(
      (key) => selectedEmails[key] === true
    );

    if ((localReportType !== '' || !isSkippable) && emails.length == 0) {
      audioMessage.info("Please select at least one email recipient for the report");
      setLoading(false);
      return;
    }

    if (reportParamsAvailable) {
      let report_config = {};
      if (localReportType !== '') {
        reportParams['send_report'] = true;

        report_config['report_date'] = reportDate;
        // The upload flow builds the force plate and testing reports with v2.
        const v2ReportTypes = { forceplate: 'forceplate-v2', testing: 'testing-v2' };
        report_config['report_type'] = v2ReportTypes[localReportType] || localReportType;
        if(reportType==='coach'){
          report_config['coaches_report'] = true;
        }
        if (localReportType === 'daily_all_tech') 
          report_config['daily_report_types'] = dailyReportTypes;
        report_config['emails'] = emails;

        if (groupByPosFor.includes(localReportType))
          report_config['group_by_pos'] = groupByPos;

        reportParams['report_config'] = report_config
      }
      else {
        reportParams['send_report'] = false;
        reportParams['report_config'] = report_config
      }
      if (dateRangeWeather){
        reportParams['weather_data'] = dateRangeWeather;
      }
      if (projectedSnapCounts){
        reportParams['projected_snap_counts'] = projectedSnapCounts;
      }
      const newUuid = crypto.randomUUID();
      setUuid(newUuid);
      setShowLiveLoading(true);
      request = trainingAPI.addTrainingV2(reportParams, newUuid);

      if (reportParams['send_report'])
        successMessage = "Trainings added and email report has been sent!";
      else successMessage = "Successfully added trainings in the system!";
    }
    else {
      if (showDailyReportType) {
        // Get all selected datatypes for daily report
        let data_types_object = {}
        dailyReportTypes.forEach((type) => {
          data_types_object[type] = true;
        });      

        if (sport === "football") {
          request = trainingAPI
          .sendDailyReportFootball({
            date: reportDate,
            data_types_object,
            emails
          });
        } else {
          request = trainingAPI
          .sendDailyReportOlympic({
            date: reportDate,
            data_types_object,
            emails
          });
        }

        successMessage = "Daily (All Tech) report email has been sent!";
      } 
      else if (localReportType === "wellness") {
        request = trainingAPI
        .wellnessEmail(reportDate, emails);

        successMessage = "Wellness report email has been sent!";
      }
      else if (localReportType === "gps") {
        if (reportType === "coach") {
          request = trainingAPI.emailGPSReport(reportDate, emails, null, null, null, true);
        }else{
        request = trainingAPI.emailGPSReport(reportDate, emails);
        }

        successMessage = "GPS report email has been sent!";
      }
      else if (localReportType === "forceplate") {
        request = trainingAPI.emailForcePlateReport(
          {
            date: reportDate,
            agg: "Avg",
            comparison: "latest_vs_prev",
            metrics: [],
            emails: emails,
            position: [],
            player_group: [],
            group_by_position: groupByPos,
          }
        );

        successMessage = "Force Plate report email has been sent!";
      }
      else if (localReportType === "testing") {
        request = trainingAPI.emailTestingReport(
          {
            date: reportDate,
            agg: "Avg",
            comparison: "latest_vs_prev",
            metrics: [],
            emails: emails,
            position: [],
            player_group: [],
            groupByPos: groupByPos,
        });
        successMessage = "Testing report email has been sent!";
      }
    }

    request.then((data) => {

      setUuid(null);
      setLoading(false);
      setReportType('');
      setReportDate(null);
      setGroupByPos(false);
      setShowGroupByPos(false);
      setShowDailyReportType(false);
      setSelectedDataType([]);
      setPickerVisible(false);
      // setLoadingDataType(false);
      setIsSubmitDisabled(false);
      setSelectedEmails({});
      setReportDateMoment(null);
      setIsPrevBtnDisabled(false);
      setDailyReportDatatypeForDate(DATA_TYPE_MAPPING);

      if (!(data instanceof Array)){
        if (data?.includes("No data found")) {
          const lines = data.split("\n");
          const title = lines[0];
          const rest = lines.slice(1, lines.length).join("\n");

          audioNotification.warning({
            message: title,
            description: (<div className="multiline-message" style={{whiteSpace: 'pre-line', textAlign: 'left'}}>{rest}</div>),
            placement: 'top',
            style: {
              width: '20rem'
            },
            duration: 10
          })
        }
      } else {
        const summaries = {};
        data.forEach(obj => {
          if (obj?.upload_summary && hasUploadSummaryDetails(obj.upload_summary)) {
            summaries[obj.source ?? 'Default'] = obj.upload_summary;
          }
        });
        if (Object.keys(summaries).length > 0) {
          setUploadSummariesBySource(summaries);
          setShowSummaryModal(true);
        }
      }

      //message.success(successMessage);
    })
    .catch((data) => {
      setUuid(null);

      if (!(data instanceof Array)){
        audioMessage.error(data);
      } else {
        let responses = data;
        const catchSummaries = {};
        let hasPendingAction = false;
        responses.forEach((response) => {
        if (response.success) {
          if (response?.upload_summary && hasUploadSummaryDetails(response.upload_summary)) {
            catchSummaries[response.source ?? 'Default'] = response.upload_summary;
          }
        } else {

          if (response?.message?.includes("Could not find player name")) {
            hasPendingAction = true;
            // This regex will parse the player name from the error message.
            // This line is dependant on the API returning an error message in the format:
            // "Could not find player name: 'mary johnson'"
            const [message, player_name] = response.message.split(":");
            const missing_player_name = player_name?.trimStart()?.slice(1, -1);
            if (missing_player_name) {
              setMissingPlayerName(missing_player_name);
            }
            const errorMsg = (
              <div>
                <a href='javascript:void(0)' onClick={toggleNicknameDialog}>Click here</a> to add a nickname for this player
              </div>
            )

            notification.error({
              key: 'nickname-notification',
              message: `Could not find player '${missing_player_name}'`,
              description: errorMsg,
              placement: 'top',
              style: {
                width: '30rem'
              },
              duration: 0
            })
          } else if (response?.message === "Outliers detected") {
            hasPendingAction = true;
            const errorMsg = (
              <div>
                <a href='javascript:void(0)' onClick={toggleOutlierDialog}><b>Click here to mark them as valid or skip them</b></a>
              </div>
            )

            setOutliers(response.outliers)

            notification.error({
              key: 'outlier-notification',
              message: <><b style={{color:'red'}}>[Action Required]</b> Potential Outliers Detected</>,
              description: <>
                <div>{errorMsg}</div>
              </>,
              placement: 'top',
              style: {
                width: '30rem',
              },
              duration: 0
            })
           }
           else if (response?.message?.includes("No full session datapoints found")) {
            if (typeof response?.message === "string" && response.message.includes("\n")) {
              // replace \n with <br> for new line
              const errorMsg = response.message.split("\n").map(e => {return(<>{e}<br/></>)})
              audioNotification.error({
                description: errorMsg,
                placement: 'top',
                style: {
                  width: '35rem'
                },
                duration: 0
              })
            } else {
              audioMessage.error(response.message);
            }
          } else {
            audioNotification.error({
              description: response.message,
              placement: 'top',
              style: {
                width: '35rem'
              },
              duration: 10
            })
          }
        }
      });
        if (!hasPendingAction && Object.keys(catchSummaries).length > 0) {
          setUploadSummariesBySource(catchSummaries);
          setShowSummaryModal(true);
        }
      }

      setLoading(false)
      if (data === "Error producing email report. Your data was saved.") {
        audioMessage.warning("Error producing email report.");
      } else {
        setLoading(false);
        // message.error("Error occurred while saving the data.");
      }
    }).finally(() => {
      setIsPrevBtnDisabled(false);
      setIsSubmitDisabled(false);
    });
  };

  useEffect(() => {
    if (!outlierDialogIsOpen && outliers.length > 0) {
      reportParams['outliers'] = outliers;
      handleSubmitReport();
      setOutliers([]);
    }
  }, [outlierDialogIsOpen]);

  const onSelectedDataTypeChange = (e, key) => {
    if (e.target.checked) {
      setDailyReportTypes([...dailyReportTypes, key]);
    }
    else {
      setDailyReportTypes(dailyReportTypes.filter(type => type != key));
    }
  }

  const renderDisconnectedPlayers = (players, label) => {
    const names = players.map(([, name]) => name);
    const extra = names.length - 3;
    return (
      <div>
        <strong>{label}</strong>{' '}
        {names.slice(0, 3).join(', ')}
        {extra > 0 && (
          <Tooltip title={names.join(', ')}>
            <span> and {extra} more</span>
          </Tooltip>
        )}
      </div>
    );
  };

  const hasUploadSummaryDetails = (summary) => {
    return !!(
      summary.skipped_player_details?.skipped_players_cnt ||
      (summary.outliers && (summary.outliers.accepted || summary.outliers.skipped)) ||
      (summary.dps_inserted && (summary.dps_inserted.full_sessions || summary.dps_inserted.drills || summary.dps_inserted.total || summary.dps_inserted.dates || summary.dps_inserted.players_cnt)) ||
      summary.sessions?.length ||
      summary.drill_names?.length ||
      summary.test_types?.length ||
      summary.exercise_types?.length ||
      summary.unrecognized_test_types?.length ||
      summary.invalid_subscription_players?.length ||
      summary.disconnected_players?.length ||
      summary.untagged_sets_cnt
    );
  };

  const selectedItemLabel = items.find(item => item.key === reportType)?.label || 'Select Report Type';
  
  return (
    <>
      { stepNum === 0 && (
        <>
        <Navbar />
        <HelpButton page="Reports" />
        </>
        )}
        {(uuid || showLiveLoading) && (<RealTimeMessageNotification title={"Uploading Data..."} uuid={uuid} />)}
      <div className="report-options-container">
        <div className="report-type">
        <Text style={{marginBottom: '1em', fontSize: 22}}>Generate a Report</Text>
          <p>Please select the type of report and date you would like to generate. {isSkippable ? <b>(Optional)</b> : <></>}</p>
          <div style={{ display: 'flex',  flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', gap: '1em' }}>
          <Dropdown 
            menu={menu}
            className="report-type-dropdown"
          >
            <Button style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              {selectedItemLabel} <CaretDownOutlined />
            </Button>
          </Dropdown>
          <DatePicker 
            style={{borderRadius: '8px'}}
            open={pickerVisible}
            onChange={dateRangeSelectionChange} 
            onOpenChange={(open) => setPickerVisible(open)}
            // ref={datePickerRef}
            value={reportDateMoment}
            allowClear
          />
          </div>

        </div>
        { showGroupByPos &&
          (
            <div className="report-groupby-position">
              <Checkbox
                style={{ marginBottom: "0.5em" }}
                checked={groupByPos}
                onChange={onToggleGroupByPos}
              >
                Group By Position
              </Checkbox>

            </div>
          )
        }
        {
          showDailyReportType && 
          (
            <div className="daily-report-type">
              <div className="daily-report-type-text">Select Data Types For Report: </div>
              <div className="select-data-types-checkbox">
                <Col style={{ marginTop: "0.5em" }}>
                  {/* {loadingDataType && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(255, 255, 255, 0.8)', // Optional: add semi-transparent background
                        zIndex: 1,
                      }}
                    >
                      <Spin size="large" />
                    </div>
                  )} */}
                  {dailyReportDataTypeForDate.map((obj, index) => (
                      <Row key={index}>

                        <Checkbox
                          checked={dailyReportTypes.includes(obj.key)}
                          onChange={(e) => onSelectedDataTypeChange(e, obj.key)}
                          value={obj.key}
                          disabled={obj.disabled}
                        >
                          {obj.label} <span style={{ fontSize: 13 }}>{obj.disabled ? "(No Data)" : ""}</span>
                        </Checkbox>
                      </Row>
                    ))}
                </Col>
              </div>
            </div>
          )
        }
        <div className="report-coach-email-list">
          <div className="daily-report-type-text">Select Email Recipients For Report: </div>
           <Col style={{ marginTop: "0.5em", overflowY: "auto", maxHeight: "120px" }}>
              {coach_list
                .filter((x) => x.email == currentUserEmail)
                .map((item) => (
                  <Row>
                    <Checkbox
                      checked={
                        selectedEmails[item.email] || false
                      }
                      onChange={() =>
                        handleEmailSelectionChange(item.email)
                      }
                    >
                      {item.first_name} {item.last_name}{" "}
                      <span style={{ fontSize: 13 }}>
                        ({item.email})
                      </span>
                    </Checkbox>
                  </Row>
                ))
              }
              {coach_list
                .filter((x) => x.email != currentUserEmail)
                .map((item, i) => (
                  <Row key={`${item.first_name}-${item.last_name}-${i}`}>
                    <Checkbox
                      checked={
                        selectedEmails[item.email] || false
                      }
                      onChange={() =>
                        handleEmailSelectionChange(item.email)
                      }
                    >
                      {item.first_name} {item.last_name}{" "}
                      <span style={{ fontSize: 13 }}>
                        ({item.email})
                      </span>
                    </Checkbox>
                  </Row>
                ))
              }
            </Col>
        </div>
        <div className="report-submit">
          {
            stepNum === 2 && (
              <Button 
                type="primary" 
                onClick={handlePrevClick}
                className="prev-btn"
                disabled={isPrevBtnDisabled}
              >
                Previous
              </Button>
          )}
          <Button 
            type="primary" 
            onClick={handleSubmitReport}
            disabled={isSubmitDisabled}
            className="submit-btn"
            loading={loading}
          >
            Submit
          </Button>
        </div>

        <NicknameDialog
          open={nicknameDialogIsOpen}
          onCancel={toggleNicknameDialog}
          missingPlayerName={missingPlayerName}
        />
        <OutlierDialog
          open={outlierDialogIsOpen}
          onCancel={toggleOutlierDialog}
          outliers={outliers}
          setUpdatedOutliers={setUpdatedOutliers}
        />
        <Modal
          title="Upload Summary"
          open={showSummaryModal}
          onCancel={() => setShowSummaryModal(false)}
          footer={
            <div style={{ textAlign: 'center' }}>
              <Button key="ok" type="primary" onClick={() => setShowSummaryModal(false)}>
                OK
              </Button>
            </div>
          }
        >
          <Collapse defaultActiveKey={Object.keys(uploadSummariesBySource)}>
            {Object.entries(uploadSummariesBySource).map(([source, summary]) => (
              <Collapse.Panel header={integrationsByKey[source]?.name ?? source} key={source}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {summary.dps_inserted?.dates != null && (
                    <div>Data found for <strong>{summary.dps_inserted.dates}</strong> dates.</div>
                  )}

                  {(summary.test_types?.length || summary.exercise_types?.length) ? (
                    <>
                      <div>
                        <strong>Exercises:</strong>{' '}
                        {[...(summary.test_types ?? []), ...(summary.exercise_types ?? [])].join(', ')}
                      </div>
                      {summary.dps_inserted?.total != null && (
                        <div><strong>Total Datapoints imported:</strong> {summary.dps_inserted.total}</div>
                      )}
                      {summary.dps_inserted?.players_cnt != null && (
                        <div><strong>Recognized players in data:</strong> {summary.dps_inserted.players_cnt}</div>
                      )}
                      {!!summary.skipped_player_details?.skipped_players_cnt && (
                        <div>
                          <strong>Unrecognized Players (Skipped):</strong> {summary.skipped_player_details.skipped_players_cnt}
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      {summary.dps_inserted?.total != null && (
                        <div><strong>Total Datapoints imported:</strong> {summary.dps_inserted.total}</div>
                      )}
                      {summary.dps_inserted && (summary.dps_inserted.full_sessions != null || summary.dps_inserted.drills != null) && (
                        <div>
                          <strong>Uploaded Datapoints:</strong>{' '}
                          {summary.dps_inserted.full_sessions ?? 0} Full Sessions, {summary.dps_inserted.drills ?? 0} Drill Sessions
                        </div>
                      )}
                      {summary.dps_inserted?.players_cnt != null && (
                        <div><strong>Recognized players in data:</strong> {summary.dps_inserted.players_cnt}</div>
                      )}
                      {summary.sessions?.length ? (
                        <div>
                          <strong>Distinct Session Names ({summary.sessions.length}):</strong>{' '}
                          {summary.sessions.join(', ')}
                        </div>
                      ) : null}
                      {summary.drill_names?.length ? (
                        <div>
                          <strong>Distinct Drill Names ({summary.drill_names.length}):</strong>{' '}
                          {summary.drill_names.join(', ')}
                        </div>
                      ) : null}
                      {summary.outliers && (summary.outliers.accepted || summary.outliers.skipped) ? (
                        <div>
                          <strong>Outliers Identified:</strong>{' '}
                          {(summary.outliers.accepted ?? 0) + (summary.outliers.skipped ?? 0)}{' '}
                          (Accepted: {summary.outliers.accepted ?? 0}, Skipped: {summary.outliers.skipped ?? 0})
                        </div>
                      ) : null}
                      {!!summary.skipped_player_details?.skipped_players_cnt && (
                        <div>
                          <strong>Skipped Datapoints due to unrecognized Player Names:</strong>{' '}
                          {summary.skipped_player_details.skipped_players_record_cnt ?? 0}{' '}
                          ({summary.skipped_player_details.skipped_players_cnt} Unrecognized Names)
                        </div>
                      )}
                    </>
                  )}

                  {summary.unrecognized_test_types?.length ? (
                    <div>
                      <strong>Unrecognized Exercises (Skipped):</strong>{' '}
                      {summary.unrecognized_test_types.join(', ')}
                    </div>
                  ) : null}
                  {!!summary.untagged_sets_cnt && (
                    <div>
                      <strong>Untagged Sets (Skipped):</strong> {summary.untagged_sets_cnt}
                    </div>
                  )}
                  {summary.invalid_subscription_players?.length
                    ? renderDisconnectedPlayers(summary.invalid_subscription_players, 'Players with disconnected Oura Rings:')
                    : null}
                  {summary.disconnected_players?.length
                    ? renderDisconnectedPlayers(summary.disconnected_players, 'Players with a disconnected WHOOP account:')
                    : null}
                </div>
              </Collapse.Panel>
            ))}
          </Collapse>
        </Modal>
        {weatherDialogVisible && <WeatherDialog
          open={weatherDialogVisible}
          dateRange={dateRange}
          dateRangeWeather={dateRangeWeather}
          setDateRangeWeather={setDateRangeWeather}
          onSubmit={handleWeatherSubmit}
          onCancel={false}
        />}
        {snapCountDialogVisible && <SnapCountDialog
          open={snapCountDialogVisible}
          csvData={reportParams?.csv_data}
          onSubmit={handleSnapCountSubmit}
        />}
      </div>
    </>
  );
};